import { render, staticRenderFns } from "./passwordFrom.vue?vue&type=template&id=1524e979&scoped=true&"
import script from "./passwordFrom.vue?vue&type=script&lang=js&"
export * from "./passwordFrom.vue?vue&type=script&lang=js&"
import style0 from "./passwordFrom.vue?vue&type=style&index=0&id=1524e979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1524e979",
  null
  
)

export default component.exports